module.exports = __webpack_public_path__ + "img/pricing_hero.f2cce9b7.webp";